<!-- 团建申请表 -->
<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>

		<Button class="submit-process" v-on:click='submit' size="large" type="primary"> 提交 </Button>

		<Spin size="large" fix v-if="spinShow"></Spin>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'

	import {
		initWxConfig
	} from "../api/jssdk.js";
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		getDepartmentInfo
	} from '@/api/department'
	import {
		AllowApplyForVerify
	} from '@/api/approval'
	var templateData = {
		TemplateContent: {
			Controls: []
		}
	};
	import {
			formatDate
		} from '@/utils/date'
	var logInfo = null;

	var isSubmit = false;

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				"templateData": templateData,
				spinShow: true,
				spNo: null,
				flowId:null
			}
		},
		mounted() { //页面挂载
			initWxConfig(this);
			this.getTemplate();
			this.spNo = this.$route.query.spNo;
		},
		created() {
		},
		methods: { //方法
			
		clickChoose: async function(dataVal, name) {
			var that = this;
			window.wx.invoke("selectEnterpriseContact", {
				"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
				"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
				"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
				"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
			}, async function(res) {
				if (res.err_msg == "selectEnterpriseContact:ok") {
					if (typeof res.result == 'string') {
						res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
					}
					var depart = res.result.departmentList[0]; // 已选的部门列表
					dataVal.Values = [];
					dataVal.Value = depart.name;
					dataVal.Values.push([depart.id, depart.name]);
					getDepartmentInfo(depart.id).then(async res => {
						var departFullName = res.Body.FullName;
						var departName = departFullName.split("/");
						var jzspValue=[];
						that.templateData.TemplateContent.Controls.forEach(async (item, index) => {
							if (item.Property.Title[0].Text == "逐级审批") {
								that.spinShow = true;
								jzspValue = await that.getDepartmentRelationList(depart.id, 10);
								that.spinShow = false;
								if (jzspValue == null || jzspValue.length <= 0) {
									jzspValue.push(that.$store.state.defaultMember);
								}
								if(jzspValue[jzspValue.length-1][0]=='SC21003035' || jzspValue[jzspValue.length-1][0]=='SC24000029'){
									jzspValue.splice(jzspValue.length-1,1);
								}
								item.Values = jzspValue;
								that.templateData.TemplateContent.Controls.forEach(e => {
									if(e.Property.Title[0].Text=="是否需要审批"){
										if (jzspValue == null || jzspValue.length <= 0) {
											e.Value=0;
											//审批节点无人，跳过
										}else{
											e.Value=1;
										}
									}
								})
								console.log(item.Values)
							}
							if (item.Property.Title[0].Text == "流程条件"){
								if(departFullName.indexOf("项目营运六部")>-1){
									item.Value = 17;
								}else if(departFullName.indexOf("项目营运一部")>-1){
									item.Value = 16;
								}else if(departFullName.indexOf("项目营运五部")>-1){
									item.Value = 15;
								}else if(departFullName.indexOf("拓展部")>-1){
									item.Value = 14;
								}else if(departFullName.indexOf("资源合作中心")>-1){
									item.Value = 13;
								}else if(departFullName.indexOf("财务中心")>-1){
									item.Value = 12;
								}else if(departFullName.indexOf("综合事务部")>-1){
									item.Value = 11;
								}else if(departFullName.indexOf("信息中心")>-1){
									item.Value = 10;
								}else if (departFullName.indexOf("后勤商业地产部") > -1){
									item.Value = 9;
								}else if (departFullName.indexOf("二级市场支援中心") > -1){
									item.Value = 7;
								}else if (departFullName.indexOf("非营业部") > -1||departFullName.indexOf("风险管理部") > -1) {
									item.Value = 6;
								} else if (departFullName.indexOf("住宅部") > -1) {
									item.Value = 1;
								} else if (departFullName.indexOf("商业地产部") > -1 && departFullName.indexOf("后勤") === -1) {
									item.Value = 2;
								} else if (logInfo.fullName.indexOf("二级市场营运中心") > -1 || logInfo.fullName.indexOf("代理") > -1) {
									item.Value = 3;
								} else if (departFullName.indexOf("藤云") > -1) {
									item.Value = 4;
								} else if (departFullName.indexOf("原友信") > -1) {
									item.Value = 5;
								} else if (departFullName.indexOf("后勤按揭部") > -1) {
									item.Value = 8;
								} else {
									item.Value = 3;
								}
							}
						})
					});
				}
			})
		},
			getTemplate: async function() {
				let that = this;
        console.log("111")
				// console.log(stringUtils.GetQueryString("templateId"))
				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + stringUtils.GetQueryString("templateId"),
					method: "get",
				}).then(async res => {
					if (res.data == null || res.data.ErrCode != 0) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '模板获取错误'
						});
						return;
					}
					var controls = res.data.Body;
					that.templateData = res.data.Body;
					if (that.templateData == null) {
						alert("模板获取错误");
						return;
					}
					logInfo = JSON.parse(localStorage.getItem('logInfo'));
					if (logInfo == null) {
						logInfo = JSON.parse(stringUtils.getCookies("logInfo"));
					}
					for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
						if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
						}else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.InCompanyDate;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.Mobile;
						}  else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
							let date = new Date();
							that.templateData.TemplateContent.Controls[i].Value = formatDate(date,"yyyy-MM-dd");
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "原职位") {
							that.templateData.TemplateContent.Controls[i].Value = "新进置业顾问1-1";
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "晋升职位") {
							that.templateData.TemplateContent.Controls[i].Value = "置业顾问2-1";
						}else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "逐级审批") {
							that.templateData.TemplateContent.Controls[i].IsShow = false;
							that.templateData.TemplateContent.Controls[i].Values = [['SC24000029','钟志斌']]
						}else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "是否需要审批") {
							that.templateData.TemplateContent.Controls[i].IsShow =false;
							that.templateData.TemplateContent.Controls[i].Value = 0;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "晋升说明") {
							that.templateData.TemplateContent.Controls[i].Value =
								`1、若当月入库，当月申请，审批完成时间为当月29号(2月为27号)18:00点前，新职位生效时间为入库当日。
2、若当月入库，当月申请，审批完成时间超过当月29号(2月为27号)18:00点，新职位生效时间为次月1号。
3、若当月入库，跨月申请，审批完成时间为申请当月29号(2月为27号)18:00点前，新职位生效时间为当月1号。
4、若当月入库，跨月申请，审批完成时间超过申请当月29号(2月为27号)18:00，新职位生效时间为申请次月1号。`;
						}
					}
					that.spinShow = false;
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
				}, err => {
					console.log(err)
				});
			},
			getTextVal() {
				console.log(this.templateData)
			},
			getSelectorVal(val) {
				var templateId = stringUtils.GetQueryString("templateId");
				var controls = this.templateData.TemplateContent.Controls;
				var i = 0;
				if (templateId == 'Bs7xbzNAeeBPD3ttT37HHJRe4KRc3bA5wURd7xTME') {
					// 是员工人事类盖章审批申请
					if (val == 'option-1595832288661' || val == 'option-1595832288662' || val == 'option-1595832288663') {
						for (i = 0; i < controls.length; i++) {
							if (controls[i].Property.Title[0].Text == '附件') {
								controls[i].Property.Require = 1;
								return;
							}
						}
					} else {
						for (i = 0; i < controls.length; i++) {
							if (controls[i].Property.Title[0].Text == '附件') {
								controls[i].Property.Require = 0;
								return;
							}
						}
					}
				}
			},
			submit() {
				let that = this;
				var controls = that.templateData.TemplateContent.Controls;
				//数据校验
				if (!this.submitValidate(controls)) {
					return;
				}
				if (isSubmit) {
					that.$message.info("已提交");
					return;
				}
				isSubmit = true;

				var SummaryList = [];
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];

				var control2 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "部门"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "申请部门：" + control2.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);


				var data = new Date();
				var month = data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
				var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
				var dateTime = data.getFullYear() + "-" + month + "-" + date;
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "申请时间：" + dateTime,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);
				this.templateData.SummaryList = SummaryList;

				that.$http.post(that.$httpUrl.startProcess + "?temId=" + stringUtils.GetQueryString("templateId") + "&empNo=" +
					logInfo.EmpNo + "&spNo=" + stringUtils.GetQueryString("spNo"), that.templateData).
				then(res => {
					isSubmit = false;
					if (res.data.ErrCode == 0) {
						that.$message.info("提交成功");
						that.$router.push("/index");
					} else {
						that.$message.error(res.data.ErrMsg);
					}
				}, err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
